import { call, takeLatest } from "redux-saga/effects";

import { Actions } from "../constants/actionTypes";
import {
  apiGetSpecificPlan,
  fetchAllPlans,
  apiGetAllLicenses,
} from "../Services/plans/plansApi";

export function* getAllPlansSaga(action) {
  yield takeLatest([Actions.API_ALL_PLANS], getAllPlans);
}

function* getAllPlans(action) {
  const result = yield call(fetchAllPlans, action);
  return result;
}

export function* apiSpecificPlan() {
  yield takeLatest([Actions.API_GET_SEPCIFIC_PLAN], specificPlan);
}

function* specificPlan(action) {
  const result = yield call(apiGetSpecificPlan, action);
  return result;
}

export function* apiAllLicenses() {
  yield takeLatest([Actions.API_GET_ALL_LICENSE], getAllLicenses);
}
function* getAllLicenses(action) {
  const result = yield call(apiGetAllLicenses, action);
  return result;
}
